<template>
    <div class="sub-page">
        <div class="block flag-block">
            <strong class="block-title">{{flagTitle}}</strong>
            <i class="block-title-line"></i>
            <div class="vw-flag-slide" v-touch-swipe.touch.left.right="flagSwipe" v-if="flagList.length">
                <ul class="flag-area" :style="{transform: `translate(${flagTrans}, 0)`}">
                    <li v-for="(img, index) in flagList" :key="img.logoId">
                        <img :src="img.logoOne" alt="" v-show="index!==flagIndex">
                        <img :src="img.logoTwo" alt="" v-show="index===flagIndex">
                    </li>
                </ul>
                <hr class="point-line">
                <ul class="flag-photo-area" :style="{transform: `translate(${flagPhotoTrans}, 0)`}">
                    <li v-for="img in flagList" :key="img.logoId">
                        <img :src="img.logoTwo" alt="">
                        <div class="flag-title">{{isCn?img.cnName:img.enName}}</div>
                        <div class="flag-text">{{isCn?img.cnContent:img.enContent}}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';

export default {
    name: 'corpFlag',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            minFlagIndex: 0,
            flagTitle: '',
            flagIndex: 0,
            flagList: [],
        };
    },
    computed: {
        flagTrans() {
            const screenWidth = window.innerWidth;
            return `${(3 - this.flagIndex) * 60 * screenWidth / 375}px`;
        },
        flagPhotoTrans() {
            const screenWidth = window.innerWidth;
            return `${-this.flagIndex * 375 * screenWidth / 375}px`;
        },
    },
    mounted() {
        ajax.get('/web/about_us/logo_list.json', {}).then((result) => {
            const logoLen = result.data.logoList.length;
            if (logoLen < 2) {
                this.flagList = result.data.logoList;
                this.flagIndex = 0;
            } else if (logoLen < 7) {
                const mid = Math.ceil(logoLen / 2);
                this.flagList = [].concat(result.data.logoList.slice(1, mid), result.data.logoList[0], result.data.logoList.slice(mid, logoLen));
                this.flagIndex = mid - 1;
            } else {
                this.flagList = [].concat(result.data.logoList.slice(1, 4), result.data.logoList[0], result.data.logoList.slice(4, logoLen));
                this.flagIndex = 3;
            }
            this.flagTitle = this.isCn ? result.data.cnTitle : result.data.enTitle;
        }).catch(() => {});
    },
    methods: {
        flagSwipe({ evt, ...info }) {
            // let index = this.serviceIndex;
            if (info.direction === 'left') {
                if (this.flagIndex < this.flagList.length - 1) {
                    this.flagIndex += 1;
                }
            } else if (info.direction === 'right') {
                if (this.flagIndex > this.minFlagIndex) {
                    this.flagIndex -= 1;
                }
            }
        },
    },
};
</script>
<style lang="less" scoped>
    .block {
        margin-top: 10px;
        background: #fff;
        padding: 15px;
        .block-title {
            display: block;
            padding-top: 8px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
        }
        .block-title-line {
            margin-top: 6px;
            display: block;
            margin: 0 auto;
            width: 22px;
            height: 2px;
            background: #C71F4B;
        }
    }
    .vw-flag-slide {
        width: 345px;
        margin: 10px auto;
        .flag-area {
            transition: transform 0.4s linear;
            display: flex;
            justify-content: left;
            align-items: center;
            flex-wrap: nowrap;
            margin-left: -38px;
            li {
                flex: 0 0 60px;
                padding: 18px 17px;
                img {
                    width: 26px;
                    height: 30px;
                }
            }
        }
        .flag-photo-area {
            transition: transform 0.4s linear;
            display: flex;
            justify-content: left;
            align-items: center;
            flex-wrap: nowrap;
            li {
                flex: 0 0 345px;
                margin-right: 30px;
                padding: 25px 0 10px;
                img {
                    display: block;
                    margin: 0 auto;
                    width: 57px;
                    height: 67px;
                }
                .flag-title {
                    padding: 14px 0 10px;
                    font-size: 14px;
                    font-weight: 600;
                    text-align: center;
                }
                .flag-text {
                    padding: 0;
                    font-size: 12px;
                    word-break: break-word;
                    color: #9B9B9B;
                }
            }
        }
    }
    .point-line {
        border: 0;
        border-top: 1px solid #C71F4B;
        height: 4px;
        background: url('../../style/image/bottom_trl.png') 50% 100% no-repeat;
        background-size: 8px 4px;
    }
</style>
